import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Select, Checkbox, DatePicker, Button, Table, Space, Modal, Spin } from "antd";
import "./supplier_master.css";
import {
    withSupplierMasterLogic,
    SupplierMasterProps,
    DataTypeCOP,
    DataTypeBank
} from "../../components/hoc_supplier_master";
import SpCop from "./sp_cop";
import SpBank from "./sp_bank";
import SpKppCode from "./sp_kpp_code";

const SupplierMaster: React.FC<SupplierMasterProps> = (props) => {

    const {
        transformStyle,
        showContentProfiel,
        setShowContentProfiel,
        showContentStatus,
        setShowContentStatus,
        showContentVAT,
        setShowContentVAT,
        showContentIncomeTax,
        setShowContentIncomeTax,
        showContentContactorPIC,
        setShowContentContactorPIC,
        showContentBank,
        setShowContentBank,
        onDateChange,
        onChangeSelect,
        selectedValuePKP,
        handleCheckboxChangePKP,
        selectedValuePKPvat,
        handleCheckboxChangePKPvat,
        columnsCOP,
        rowSelectionCOP,
        selectedRowKeysCOP,
        copData,
        columnsBank,
        rowSelectionBank,
        bankData,
        formInitialValues,
        isLoadingNextCode,
        form,
        provinsiOptions,
        isLoadingProvinsi,
        onProvinsiChange,
        kabupatenOptions,
        isLoadingKabupaten,
        selectedKodeProvinsi,
        onKabupatenChange,
        kecamatanOptions,
        isLoadingKecamatan,
        selectedKodeDati,
        onKecamatanChange,
        kelurahanOptions,
        isLoadingKelurahan,
        selectedKodeKecamatan,
        onKelurahanChange,
        onProvinsiChangeVAT,
        kabupatenOptionsVAT,
        isLoadingKabupatenVAT,
        selectedKodeProvinsiVAT,
        onKabupatenChangeVAT,
        kecamatanOptionsVAT,
        isLoadingKecamatanVAT,
        selectedKodeDatiVAT,
        onKecamatanChangeVAT,
        kelurahanOptionsVAT,
        isLoadingKelurahanVAT,
        selectedKodeKecamatanVAT,
        onKelurahanChangeVAT,
        onProvinsiChangeIncomeTax,
        kabupatenOptionsIncomeTax,
        isLoadingKabupatenIncomeTax,
        selectedKodeProvinsiIncomeTax,
        onKabupatenChangeIncomeTax,
        kecamatanOptionsIncomeTax,
        isLoadingKecamatanIncomeTax,
        selectedKodeDatiIncomeTax,
        onKecamatanChangeIncomeTax,
        kelurahanOptionsIncomeTax,
        isLoadingKelurahanIncomeTax,
        selectedKodeKecamatanIncomeTax,
        onKelurahanChangeIncomeTax,
        vatTransOptions,
        isLoadingVatTrans,
        isCopModalVisible,
        showCopModal,
        handleCopModalCancel,
        handleCopModalOk,
        handleCopRowDoubleClick,
        isEditMode,
        editingCopRecord,
        handleActivateCop,
        handleDeactivateCop,
        isBankModalVisible,
        showBankModal,
        handleBankModalCancel,
        handleBankModalOk: handleBankModalSubmit,
        handleBankRowDoubleClick,
        isBankEditMode,
        editingBankRecord,
        handleActivateBank,
        handleDeactivateBank,
        isBankActionButtonDisabled,
        selectedRowKeysBank,
        handleSave,
        isSaving,
        isEditModeMaster,
        supplierId,
        isLoadingSupplierData,
        isKppModalVisible,
        showKppModal,
        handleKppModalCancel,
        handleKppModalOk,
    } = props;
    const isCopActionButtonDisabled = selectedRowKeysCOP.length === 0;
    if (isEditModeMaster && isLoadingSupplierData) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <Spin size="large" tip="Loading Supplier Data..." />
            </div>
        );
    }

    return (

        <div id="iau9" style={transformStyle}>

            <div className="gjs-grid-row" id="i121c">
                <div className="gjs-grid-column" id="iyyt5">
                    <Breadcrumb
                        items={[
                            {
                                href: "",
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_supplier_master",
                                title: (
                                    <>
                                        <UserOutlined />
                                        <span>Data Supplier</span>
                                    </>
                                ),
                            },
                            {
                                title: "Supplier Master",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="wwadas2">
                <div className="gjs-grid-column" id="w748wdw22s">
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z" clipRule="evenodd" />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg> New
                    </Button>
                    <Button
                        className="pr-button"
                        onClick={handleSave}
                        loading={isSaving}
                        disabled={isSaving}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z" clipRule="evenodd" />
                        </svg> {isEditModeMaster ? 'Update' : 'Save'}
                    </Button>
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg> Submit
                    </Button>
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clipRule="evenodd" />
                        </svg> Void
                    </Button>
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg> Close Order
                    </Button>
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M7.875 1.5C6.839 1.5 6 2.34 6 3.375v2.99c-.426.053-.851.11-1.274.174-1.454.218-2.476 1.483-2.476 2.917v6.294a3 3 0 0 0 3 3h.27l-.155 1.705A1.875 1.875 0 0 0 7.232 22.5h9.536a1.875 1.875 0 0 0 1.867-2.045l-.155-1.705h.27a3 3 0 0 0 3-3V9.456c0-1.434-1.022-2.7-2.476-2.917A48.716 48.716 0 0 0 18 6.366V3.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM16.5 6.205v-2.83A.375.375 0 0 0 16.125 3h-8.25a.375.375 0 0 0-.375.375v2.83a49.353 49.353 0 0 1 9 0Zm-.217 8.265c.178.018.317.16.333.337l.526 5.784a.375.375 0 0 1-.374.409H7.232a.375.375 0 0 1-.374-.409l.526-5.784a.373.373 0 0 1 .333-.337 41.741 41.741 0 0 1 8.566 0Zm.967-3.97a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75H18a.75.75 0 0 1-.75-.75V10.5ZM15 9.75a.75.75 0 0 0-.75.75v.008c0 .414.336.75.75.75h.008a.75.75 0 0 0 .75-.75V10.5a.75.75 0 0 0-.75-.75H15Z" clipRule="evenodd" />
                        </svg> Print
                    </Button>
                </div>
            </div>

            <div className="gjs-grid-row" id="ibq6j">
                <div className="gjs-grid-column" id="i82b9">

                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 530 }}
                        labelCol={{ style: { width: '190px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '320px' } }}
                        className="custom-info-purchase-request"
                        initialValues={formInitialValues}
                    >
                        <Form.Item
                            label="Status"
                            name="status"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Supplier Code"
                            name="supplier_code"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="Generating code..." readOnly disabled={isLoadingNextCode} />
                        </Form.Item>
                        <Form.Item
                            label="Supplier Name"
                            name="supplier_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Term of Payment "
                            name="term_of_payment"
                            style={{ marginBottom: "5px" }}>
                            <Select
                                showSearch
                                placeholder="Select Term of Payment "
                                optionFilterProp="label"
                                onChange={onChangeSelect} // Use prop
                                options={[
                                    { value: "COD", label: "Cash on Delivery" },
                                    { value: "CR3", label: "Credit 3 Days" },
                                    { value: "CR7", label: "Credit 7 Days" },
                                    { value: "CR14", label: "Credit 14 Days" },
                                    { value: "CR21", label: "Credit 21 Days" },
                                    { value: "CR30", label: "Credit 30 Days" },
                                    { value: "CR35", label: "Credit 35 Days" },
                                    { value: "CR42", label: "Credit 42 Days" },
                                    { value: "CR45", label: "Credit 45 Days" },
                                    { value: "CR60", label: "Credit 60 Days" },
                                    { value: "CR90", label: "Credit 90 Days" },
                                    { value: "CR120", label: "Credit 120 Days" },
                                    { value: "CR180", label: "Credit 180 Days" },

                                ]}
                                style={{ width: "100%" }}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            />
                        </Form.Item>
                        <div className="grid-2">

                            <Form.Item
                                label="Profile"
                                style={{
                                    marginBottom: "0px",
                                }}
                            >
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}
                                >
                                    <Checkbox
                                        onChange={(e) => setShowContentProfiel(e.target.checked)}
                                    >
                                        Show
                                    </Checkbox>
                                </div>
                            </Form.Item>


                            {showContentProfiel && (
                                <>
                                    <Form.Item
                                        label="ID No"
                                        name="id_no"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Address"
                                        name="address"
                                        style={{ marginBottom: 4 }}
                                    >
                                        <Input.TextArea placeholder="Address" rows={5} />
                                    </Form.Item>

                                    <Form.Item
                                        label="RT/RW"
                                        name="rt_rw"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Provinsi" name="provinsi" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Provinsi"
                                            optionFilterProp="label"
                                            onChange={onProvinsiChange}
                                            options={provinsiOptions}
                                            loading={isLoadingProvinsi}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kabupaten" name="kabupaten" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kabupaten"
                                            optionFilterProp="label"
                                            onChange={onKabupatenChange}
                                            options={kabupatenOptions}
                                            loading={isLoadingKabupaten}
                                            disabled={!selectedKodeProvinsi || isLoadingKabupaten}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kecamatan" name="kecamatan" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kecamatan"
                                            optionFilterProp="label"
                                            onChange={onKecamatanChange}
                                            options={kecamatanOptions}
                                            loading={isLoadingKecamatan}
                                            disabled={!selectedKodeDati || isLoadingKecamatan}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kelurahan" name="kelurahan" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kelurahan"
                                            optionFilterProp="label"
                                            onChange={onKelurahanChange}
                                            options={kelurahanOptions}
                                            loading={isLoadingKelurahan}
                                            disabled={!selectedKodeKecamatan || isLoadingKelurahan}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kode Pos"
                                        name="kode_pos"
                                        style={{
                                            marginBottom: "5px", width: "50%",
                                        }}
                                    >
                                        <Input placeholder="" disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="Phone"
                                        name="phone"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Email"
                                        name="email"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </>
                            )}
                        </div>
                        <div className="grid-2">
                            { }
                            <Form.Item
                                label="Status"
                                style={{
                                    marginBottom: "0px",
                                }}
                            >
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}
                                >
                                    <Checkbox checked={showContentStatus} onChange={(e) => setShowContentStatus(e.target.checked)}> Show </Checkbox>
                                </div>
                            </Form.Item>

                            { }
                            {showContentStatus && (
                                <>
                                    <Form.Item
                                        label="Minimum Down Payment"
                                        name="minimum_down_payment"
                                        style={{
                                            marginBottom: "5px",
                                            width: "50%",
                                        }}
                                    >
                                        <Input addonAfter="%" placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Tax Industry"
                                        name="tax_industry"
                                        style={{
                                            marginBottom: "5px",
                                            width: "50%",
                                        }}
                                    >
                                        <Input addonAfter="%" placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Discount"
                                        name="discount"
                                        style={{
                                            marginBottom: "5px",
                                            width: "50%",
                                        }}
                                    >
                                        <Input addonAfter="%" placeholder="" />
                                    </Form.Item>
                                </>
                            )}
                        </div>
                        <div className="grid-2">
                            { }
                            <Form.Item
                                label="VAT"
                                style={{
                                    marginBottom: "0px",
                                }}
                            >
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}
                                >
                                    <Checkbox checked={showContentVAT} onChange={(e) => setShowContentVAT(e.target.checked)}> Show </Checkbox>
                                </div>
                            </Form.Item>

                            { }
                            {showContentVAT && (
                                <>
                                    <Form.Item
                                        label="NPWP"
                                        name="npwp"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="NPWP Date"
                                        name="npwp_date"
                                        style={{
                                            marginBottom: "5px", // Menambahkan jarak antar item
                                        }}
                                    >
                                        <DatePicker
                                            onChange={onDateChange}
                                            format="DD/MM/YYYY" // Format dd/MM/yyyy
                                            placeholder="Select date"
                                            style={{ width: "40%", fontSize: "14px" }}
                                            popupStyle={{ fontSize: "12px" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="PKP"
                                        name="pkp"
                                        style={{
                                            marginBottom: "5px", // Menambahkan jarak antar item
                                        }}
                                    >
                                        <div
                                            style={{
                                                gap: "10px", // Jarak antar checkbox
                                                marginTop: "0px",
                                                display: "flex",
                                            }}
                                        >
                                            <Checkbox checked={selectedValuePKP === "Yes"} onChange={() => handleCheckboxChangePKP("Yes")}> Yes </Checkbox>
                                            <Checkbox checked={selectedValuePKP === "No"} onChange={() => handleCheckboxChangePKP("No")}> No </Checkbox>
                                        </div>
                                    </Form.Item>
                                    <Form.Item
                                        label="PKP No"
                                        name="pkp_no"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="PKP Date"
                                        name="pkp_date"
                                        style={{
                                            marginBottom: "5px", // Menambahkan jarak antar item
                                        }}
                                    >
                                        <DatePicker
                                            onChange={onDateChange}
                                            format="DD/MM/YYYY" // Format dd/MM/yyyy
                                            placeholder="Select date"
                                            style={{ width: "40%", fontSize: "14px" }}
                                            popupStyle={{ fontSize: "12px" }}
                                        />
                                    </Form.Item>
                                    <Form.Item label="VAT Transaction Code" name="vat_transaction_code" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select VAT Transaction Code"
                                            optionFilterProp="label"
                                            onChange={onChangeSelect}
                                            options={vatTransOptions}
                                            loading={isLoadingVatTrans}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Name"
                                        name="vat_name"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Address"
                                        name="vat_address"
                                        style={{ marginBottom: 4 }}
                                    >
                                        <Input.TextArea placeholder="Address" rows={5} />
                                    </Form.Item>
                                    <Form.Item
                                        label="RT/RW"
                                        name="vat_rt_rw"
                                        style={{
                                            marginBottom: "5px", width: "50%"
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Provinsi" name="vat_provinsi" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Provinsi"
                                            optionFilterProp="label"
                                            onChange={onProvinsiChangeVAT} // <-- Gunakan handler VAT
                                            options={provinsiOptions} // <-- Bisa reuse opsi provinsi utama
                                            loading={isLoadingProvinsi} // <-- Bisa reuse loading provinsi utama
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kabupaten" name="vat_kabupaten" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kabupaten"
                                            optionFilterProp="label"
                                            onChange={onKabupatenChangeVAT}
                                            options={kabupatenOptionsVAT}
                                            loading={isLoadingKabupatenVAT}
                                            disabled={!selectedKodeProvinsiVAT || isLoadingKabupatenVAT}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kecamatan" name="vat_kecamatan" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kecamatan"
                                            optionFilterProp="label"
                                            onChange={onKecamatanChangeVAT} // <-- Gunakan handler VAT
                                            options={kecamatanOptionsVAT} // <-- Gunakan opsi VAT
                                            loading={isLoadingKecamatanVAT} // <-- Gunakan loading VAT
                                            disabled={!selectedKodeDatiVAT || isLoadingKecamatanVAT} // <-- Gunakan state VAT
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kelurahan" name="vat_kelurahan" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kelurahan"
                                            optionFilterProp="label"
                                            onChange={onKelurahanChangeVAT} 
                                            options={kelurahanOptionsVAT} 
                                            loading={isLoadingKelurahanVAT} 
                                            disabled={!selectedKodeKecamatanVAT || isLoadingKelurahanVAT} 
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kode Pos"
                                        name="vat_kode_pos"
                                        style={{
                                            marginBottom: "5px", width: "50%",
                                        }}
                                    >
                                        <Input placeholder="" disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="KPP Code"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >

                                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                            <Form.Item
                                                name="kpp_code"
                                                style={{
                                                    marginBottom: 0,
                                                    flexGrow: 1,
                                                    width: '40%'
                                                }}

                                            >
                                                <Input placeholder="KPP Code" />
                                            </Form.Item>

                                            <Button
                                                type="primary"
                                                name="kpp_list1"
                                                onClick={() => showKppModal('vat')}
                                                icon={
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        fill="currentColor"
                                                        style={{ width: "20px", height: "20px", display: 'block' }}
                                                    >
                                                        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                            clipRule="evenodd"
                                                        />
                                                        <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                    </svg>
                                                }
                                                style={{ flexShrink: 0 }}
                                            />
                                            <Form.Item
                                                name="kpp_name"
                                                style={{
                                                    marginBottom: 0,
                                                    flexGrow: 2,
                                                }}
                                            >
                                                <Input placeholder="KPP Name" />
                                            </Form.Item>
                                        </div>
                                    </Form.Item>
                                </>
                            )}
                        </div>
                        <div className="grid-2">
                            <Form.Item
                                label="Income Tax"
                                style={{
                                    marginBottom: "0px",
                                }}
                            >
                                <div
                                    style={{
                                        gap: "0px",
                                        marginTop: "0px",
                                    }}
                                >
                                    <Checkbox checked={showContentIncomeTax} onChange={(e) => setShowContentIncomeTax(e.target.checked)}> Show </Checkbox>
                                </div>
                            </Form.Item>
                            {showContentIncomeTax && (
                                <>
                                    <Form.Item
                                        label="Same as VAT"
                                        name="same_as_vat"
                                        valuePropName="checked"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Checkbox>Yes</Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                        label="NPWP"
                                        name="income_tax_npwp"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="NPWP Date"
                                        name="income_tax_npwp_date"
                                        style={{
                                            marginBottom: "5px", // Menambahkan jarak antar item
                                        }}
                                    >
                                        <DatePicker
                                            onChange={onDateChange}
                                            format="DD/MM/YYYY" // Format dd/MM/yyyy
                                            placeholder="Select date"
                                            style={{ width: "40%", fontSize: "14px" }}
                                            popupStyle={{ fontSize: "12px" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="PKP"
                                        name="income_tax_pkp"
                                        style={{
                                            marginBottom: "5px", // Menambahkan jarak antar item
                                        }}
                                    >
                                        <div
                                            style={{
                                                gap: "10px", // Jarak antar checkbox
                                                marginTop: "0px",
                                                display: "flex",
                                            }}
                                        >
                                            <Checkbox
                                                checked={selectedValuePKP === "Yes"}
                                                onChange={() => handleCheckboxChangePKP("Yes")}
                                            >
                                                Yes
                                            </Checkbox>
                                            <Checkbox
                                                checked={selectedValuePKP === "No"}
                                                onChange={() => handleCheckboxChangePKP("No")}
                                            >
                                                No
                                            </Checkbox>
                                        </div>
                                    </Form.Item>
                                    <Form.Item
                                        label="PKP No"
                                        name="income_tax_pkp_no"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="PKP Date"
                                        name="income_tax_pkp_date"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <DatePicker
                                            onChange={onDateChange}
                                            format="DD/MM/YYYY"
                                            placeholder="Select date"
                                            style={{ width: "40%", fontSize: "14px" }}
                                            popupStyle={{ fontSize: "12px" }}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Name"
                                        name="income_tax_name"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item
                                        label="Address"
                                        name="income_tax_address"
                                        style={{ marginBottom: 4 }}
                                    >
                                        <Input.TextArea placeholder="Address" rows={5} />
                                    </Form.Item>
                                    <Form.Item
                                        label="RT/RW"
                                        name="income_tax_rt_rw"
                                        style={{
                                            marginBottom: "5px", width: "50%"
                                        }}
                                    >
                                        <Input placeholder="" />
                                    </Form.Item>
                                    <Form.Item label="Provinsi" name="income_tax_provinsi" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Provinsi"
                                            optionFilterProp="label"
                                            onChange={onProvinsiChangeIncomeTax}
                                            options={provinsiOptions}
                                            loading={isLoadingProvinsi}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kabupaten" name="income_tax_kabupaten" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kabupaten"
                                            optionFilterProp="label"
                                            onChange={onKabupatenChangeIncomeTax}
                                            options={kabupatenOptionsIncomeTax}
                                            loading={isLoadingKabupatenIncomeTax}
                                            disabled={!selectedKodeProvinsiIncomeTax || isLoadingKabupatenIncomeTax}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kecamatan" name="income_tax_kecamatan" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kecamatan"
                                            optionFilterProp="label"
                                            onChange={onKecamatanChangeIncomeTax}
                                            options={kecamatanOptionsIncomeTax}
                                            loading={isLoadingKecamatanIncomeTax}
                                            disabled={!selectedKodeDatiIncomeTax || isLoadingKecamatanIncomeTax}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item label="Kelurahan" name="income_tax_kelurahan" style={{ marginBottom: "5px" }}>
                                        <Select
                                            showSearch
                                            placeholder="Select Kelurahan"
                                            optionFilterProp="label"
                                            onChange={onKelurahanChangeIncomeTax}
                                            options={kelurahanOptionsIncomeTax}
                                            loading={isLoadingKelurahanIncomeTax}
                                            disabled={!selectedKodeKecamatanIncomeTax || isLoadingKelurahanIncomeTax}
                                            style={{ width: "100%" }}
                                            getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label="Kode Pos"
                                        name="income_tax_kode_pos"
                                        style={{
                                            marginBottom: "5px", width: "50%",
                                        }}
                                    >
                                        <Input placeholder="" disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="KPP Code"
                                        style={{
                                            marginBottom: "5px",
                                        }}
                                    >

                                        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                            <Form.Item
                                                name="income_tax_kpp_code"
                                                style={{
                                                    marginBottom: 0,
                                                    flexGrow: 1,
                                                    width: '40%'
                                                }}

                                            >
                                                <Input placeholder="KPP Code" />
                                            </Form.Item>

                                            <Button
                                                type="primary"
                                                name="kpp_list2"
                                                onClick={() => showKppModal('income_tax')}
                                                icon={
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 24 24"
                                                        fill="currentColor"
                                                        style={{ width: "20px", height: "20px", display: 'block' }}
                                                    >
                                                        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                        <path
                                                            fillRule="evenodd"
                                                            d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                            clipRule="evenodd"
                                                        />
                                                        <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                                    </svg>
                                                }
                                                style={{ flexShrink: 0 }}
                                            />
                                            <Form.Item
                                                name="income_tax_kpp_name"
                                                style={{
                                                    marginBottom: 0,
                                                    flexGrow: 2,
                                                }}
                                            >
                                                <Input placeholder="KPP Name" />
                                            </Form.Item>
                                        </div>
                                    </Form.Item>

                                </>
                            )}
                        </div>
                    </Form>

                </div>
            </div>
            <div className="gjs-grid-row" id="iq6nx">
                <div className="gjs-grid-column" id="ip45e">
                    <div className="grid-2">

                        <Form.Item
                            label="Contact or PIC"
                            style={{
                                marginBottom: "0px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        minWidth: "76px",
                                    }}
                                ></div>
                                <Checkbox checked={showContentContactorPIC} onChange={(e) => setShowContentContactorPIC(e.target.checked)}> Show </Checkbox>
                            </div>
                        </Form.Item>


                        {showContentContactorPIC && (
                            <>
                                <Table<DataTypeCOP>
                                    rowSelection={rowSelectionCOP}
                                    columns={columnsCOP}
                                    style={{ paddingRight: '30px' }}
                                    dataSource={copData}
                                    scroll={{ x: 900 }}
                                    className="table-gr"
                                    onRow={(record) => ({ onDoubleClick: () => handleCopRowDoubleClick(record) })}
                                />
                                <div style={{ marginTop: "20px", textAlign: "left" }}>
                                    <Space>
                                        <Button
                                            type="primary"
                                            onClick={showCopModal}
                                            style={{
                                                height: "40px",
                                                width: "105px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            icon={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    style={{ width: "22px", height: "22px" }}
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            }
                                        >
                                            Add
                                        </Button>
                                        <Button
                                            type="primary"
                                            onClick={handleActivateCop} // Hubungkan handler
                                            disabled={isCopActionButtonDisabled}
                                            style={{
                                                height: "40px",
                                                width: "100px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            icon={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    style={{ width: "22px", height: "22px" }}
                                                >
                                                    <path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
                                                </svg>
                                            }
                                        >
                                            Active
                                        </Button>
                                        <Button
                                            type="primary"
                                            onClick={handleDeactivateCop} // Hubungkan handler
                                            disabled={isCopActionButtonDisabled}
                                            style={{
                                                height: "40px",
                                                width: "120px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            icon={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    style={{ width: "22px", height: "22px" }}
                                                >
                                                    <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clipRule="evenodd" />
                                                </svg>
                                            }
                                        >
                                            Deactive
                                        </Button>
                                    </Space>
                                </div>
                            </>
                        )}
                    </div>
                    <div className="grid-2">
                        <Form.Item
                            label="Bank"
                            style={{
                                marginBottom: "0px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        minWidth: "143px",
                                    }}
                                ></div>
                                <Checkbox checked={showContentBank} onChange={(e) => setShowContentBank(e.target.checked)}> Show </Checkbox>
                            </div>
                        </Form.Item>
                        {showContentBank && (
                            <>
                                <Table<DataTypeBank>
                                    rowSelection={rowSelectionBank}
                                    columns={columnsBank}
                                    style={{ paddingRight: '30px' }}
                                    dataSource={bankData}
                                    scroll={{ x: 900 }}
                                    className="table-gr"
                                    onRow={(record) => ({ // Tambahkan onRow
                                        onDoubleClick: () => handleBankRowDoubleClick(record), // Panggil handler dari HOC saat double click
                                    })}
                                />
                                <div style={{ marginTop: "20px", textAlign: "left" }}>
                                    <Space>
                                        <Button
                                            type="primary"
                                            onClick={showBankModal}
                                            style={{
                                                height: "40px",
                                                width: "105px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            icon={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    style={{ width: "22px", height: "22px" }}
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 9a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V15a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V9Z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            }
                                        >
                                            Add Line
                                        </Button>
                                        <Button
                                            type="primary"
                                            onClick={handleActivateBank} // Hubungkan ke fungsi handleActivateBank
                                            disabled={isBankActionButtonDisabled}
                                            style={{
                                                height: "40px",
                                                width: "100px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            icon={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    style={{ width: "22px", height: "22px" }}
                                                >
                                                    <path d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 0 1-1.5 0V6.75a3.75 3.75 0 1 0-7.5 0v3a3 3 0 0 1 3 3v6.75a3 3 0 0 1-3 3H3.75a3 3 0 0 1-3-3v-6.75a3 3 0 0 1 3-3h9v-3c0-2.9 2.35-5.25 5.25-5.25Z" />
                                                </svg>
                                            }
                                        >
                                            Active
                                        </Button>
                                        <Button
                                            type="primary"
                                            onClick={handleDeactivateBank} // Hubungkan ke fungsi handleDeactivateBank
                                            disabled={isBankActionButtonDisabled}
                                            style={{
                                                height: "40px",
                                                width: "120px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                            icon={
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    fill="currentColor"
                                                    style={{ width: "22px", height: "22px" }}
                                                >
                                                    <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clipRule="evenodd" />
                                                </svg>
                                            }
                                        >
                                            Deactive
                                        </Button>
                                    </Space>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Modal
                title={isEditMode ? "Edit Contact / PIC" : "Add Contact / PIC"}
                open={isCopModalVisible}
                onCancel={handleCopModalCancel}
                destroyOnClose
                footer={null}
                width={400}
                className="sp-cop"
            >
                <SpCop
                    onCancel={handleCopModalCancel}
                    onSubmit={handleCopModalOk}
                    initialData={editingCopRecord}
                    isEditMode={isEditMode}
                />
            </Modal>
            <Modal
                title={isBankEditMode ? "Edit Bank" : "Add Bank"}
                open={isBankModalVisible}
                onCancel={handleBankModalCancel}
                destroyOnClose
                footer={null}
                width={400}
                className="sp-bank-modal"
            >
                <SpBank
                    onCancel={handleBankModalCancel}
                    onSubmit={handleBankModalSubmit}
                    initialData={editingBankRecord}
                    isEditMode={isBankEditMode}
                />
            </Modal>
            <Modal
                title="Pilih Kode KPP" 
                open={isKppModalVisible}
                onCancel={handleKppModalCancel} 
                destroyOnClose 
                footer={null} 
                width={600} 
            
            >
                 <SpKppCode onOk={handleKppModalOk} />

            </Modal>
        </div>
    );
};

export default withSupplierMasterLogic(SupplierMaster);